import React, { useEffect, useState } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import striptags from "striptags";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const Loader = dynamic(() =>
  import("../../../components/common/Loader/Loader")
);
const Layout = dynamic(() =>
  import("../../../components/common/Layout/Layout")
);
const ServiceLandingPage = dynamic(() =>
  import("../../../components/Service/ServiceLandingPage")
);

const Service = ({ apiData }) => {
  const router = useRouter();
  const { category } = router.query;

  const [loader, setLoader] = useState(true);
  const [localData, setLocalData] = useState(null);

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );



  /* -----------------------------
     SEO DATA CLEANING
  ----------------------------- */

  const cleanPageTitle = striptags(apiData?.page_title || "").trim();
  const seo_title = striptags(apiData?.meta?.seo_title || "").trim();
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const title =
    cleanPageTitle ||
    seo_title ||
    `${category?.replace(/-/g, " ")} | Quixom Technology`;

  const search_description = apiData?.meta?.search_description || "";

  const canonicalUrl =
    apiData?.canonical_url ||
    `${process.env.NEXT_PUBLIC_BASE_URL}/services/${category}`;

  const structuredData = apiData?.struct_org_extra_json;

  const formatJson = (json) => ({
    __html: `${json}`,
  });

  return (
    <>
      <Head>
        <title>{title}</title>

        {seo_title && <meta name="title" content={seo_title} />}

        {search_description && (
          <meta name="description" content={search_description} />
        )}

        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>

      <Layout footerData={footerData}>
        <ServiceLandingPage key={category} apiData={apiData} />
      </Layout>
    </>
  );
};

/* --------------------------------
   SERVER SIDE DATA FETCH
-------------------------------- */

export async function getServerSideProps(context) {
  try {
    const { category } = context.params;

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_ENDPOINT}/cms/pages/${category}`
    );

    const apiData = await response.json();

    if (apiData?.redirect_url) {
      return {
        redirect: {
          destination: apiData.redirect_url,
          permanent: false,
        },
      };
    }

    return {
      props: {
        apiData,
      },
    };
  } catch (error) {
    console.error("Service page fetch error:", error);

    return {
      props: {
        apiData: null,
      },
    };
  }
}

export default Service;